import * as React from "react";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import FormHelperText from "@mui/material/FormHelperText";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import {
  IconButton,
  CircularProgress,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  programmeDetailApi,
  SaveAsTemplateProgrammeApi,
} from "src/DAL/Programme/Programme";
import { s3baseUrl } from "../../../config/config";
import TinyEditor from "src/components/ckeditor/Ckeditor";
import { get_root_value } from "src/utils/domUtils";
import { useEffect } from "react";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "10%",
  },
}));

const Input = styled("input")({
  display: "none",
});

export default function SaveAsProgrammeTemplate({ open, setOpen, data }) {
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [file, setProfileImage] = useState();
  const [navItems, setNavitems] = useState([]);
  const [programmeDetail, setProgrammeDetail] = useState([]);
  const [fileNew, setProfileImageNew] = useState(false);
  const [detailDescriptionCk, setDetailDescriptionCk] = useState();
  const [weeklength, setWeeklength] = useState();

  const [inputs, setInputs] = useState({
    title: "",
    programStatus: "",
    showStatus: "",
    image: {},
    accessType: "",
    videoUrl: "",
    short_description: "",
    detailed_description: "",
    video_show_Status: "",
    image_show: "",
    no_of_limited_days: "",
    no_of_weeks: 0,
    order: "",
    color: "#0096FF",
    isRecurring: false,
    recurringDays: 0,
    form_template: null,
    is_coach_assigned: false,
    program_type: "general",
  });

  const handleClose = () => {
    setIsLoading(false);
    setOpen(false);
  };

  const getProgrammeDetail = async () => {
    setIsLoading(true);
    const result = await programmeDetailApi(data?._id);
    if (result.code === 200) {
      setProgrammeDetail(result.program);
      setDetailDescriptionCk(result?.program?.detailed_description);
      setInputs((prevState) => ({
        ...prevState,
        ["title"]: result?.program?.title,
        ["short_description"]: result?.program?.short_description,
        ["detailed_description"]: result?.program?.detailed_description,
        ["videoUrl"]: result?.program?.video_url,
        ["programStatus"]: result?.program?.status,
        ["showStatus"]: result?.program?.is_program_show_on_list,
        ["accessType"]: result?.program?.program_length_type,
        ["image_show"]: result?.program?.program_images?.thumbnail_1,
        ["no_of_limited_days"]: result?.program?.no_of_limited_days,
        ["no_of_weeks"]: result?.program?.no_of_weeks,
        ["color"]: result?.program?.color,
        ["order"]: result?.program?.order,
        ["program_type"]: result?.program?.program_type,
        ["is_coach_assigned"]: result?.program?.is_coach_assigned,
      }));
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const fileChangedHandler = (e) => {
    setProfileImage(URL.createObjectURL(e.target.files[0]));
    setProfileImageNew(true);
    setInputs({
      ...inputs,
      ["image"]: e.target.files[0],
    });
  };

  const urlPatternValidation = (URL) => {
    const regex = new RegExp(
      "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?",
    );
    return regex.test(URL);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      urlPatternValidation(inputs.videoUrl) === false &&
      inputs.videoUrl !== ""
    ) {
      enqueueSnackbar("Enter Valid Video URL", { variant: "error" });
    } else {
      if (inputs.days < 0) {
        enqueueSnackbar("No of days must be positive number ", {
          variant: "error",
        });
      } else if (inputs?.accessType == "limited" && inputs.no_of_weeks < 1) {
        enqueueSnackbar("No of start days at least 1 ", {
          variant: "error",
        });
      } else if (
        inputs?.isRecurring &&
        inputs.accessType == "limited" &&
        inputs.recurringDays > inputs.no_of_weeks * 7
      ) {
        enqueueSnackbar(
          ` Enter No of Recurring days between (1 to ${
            inputs.no_of_weeks * 7
          })`,
          {
            variant: "error",
          },
        );
        return;
      } else if (fileNew && !inputs.image) {
        enqueueSnackbar("Please upload image", { variant: "error" });
      } else if (detailDescriptionCk == "") {
        enqueueSnackbar("Enter Detail Description", { variant: "error" });
      } else {
        const formData = new FormData();
        formData.append("title", inputs.title);
        formData.append("program_type", inputs.program_type);
        formData.append("short_description", inputs.short_description);
        formData.append("detailed_description", detailDescriptionCk);
        formData.append("status", inputs.programStatus);
        formData.append("video_url", inputs.videoUrl);
        formData.append("is_coach_assigned", inputs.is_coach_assigned);
        formData.append("nav_items", JSON.stringify(navItems));
        formData.append(
          "no_of_weeks",
          inputs.no_of_weeks ? inputs.no_of_weeks : 0,
        );
        formData.append("color", inputs.color);
        formData.append("program_id", data?._id);

        if (fileNew == true) {
          formData.append("main_image", inputs.image);
        }

        setIsLoading(true);
        const result = await SaveAsTemplateProgrammeApi(formData);
        if (result.code === 200) {
          enqueueSnackbar(result.message, { variant: "success" });
          handleClose();
        } else {
          enqueueSnackbar(result.message, { variant: "error" });
          setIsLoading(false);
        }
      }
    }
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  useEffect(() => {
    if (open) {
      getProgrammeDetail();
      setNavitems(data?.nav_items ? data?.nav_items : []);
    }
  }, [open]);

  useEffect(() => {
    setProfileImage();
    setProfileImageNew();
    setDetailDescriptionCk(programmeDetail.detailed_description);
    setWeeklength(programmeDetail.no_of_weeks);
    setInputs((prevState) => ({
      ...prevState,
      ["title"]: programmeDetail.title,
      ["short_description"]: programmeDetail.short_description,
      ["detailed_description"]: programmeDetail.detailed_description,
      ["videoUrl"]: programmeDetail.video_url,
      ["is_coach_assigned"]: programmeDetail.is_coach_assigned,
      ["programStatus"]: programmeDetail.status,
      ["showStatus"]: programmeDetail.is_program_show_on_list,
      ["accessType"]: programmeDetail.program_access_type,
      ["image_show"]: programmeDetail.program_images?.thumbnail_1,
      ["image"]: "",

      ["no_of_limited_days"]: programmeDetail.no_of_limited_days,
      ["no_of_weeks"]: programmeDetail.no_of_weeks,
      ["order"]: programmeDetail.order,
    }));
  }, [programmeDetail]);

  return (
    <div className="container">
      <Dialog
        open={open}
        fullScreen={window.innerWidth <= 550 ? true : false}
        fullWidth
        maxWidth={"md"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id="show-dialog-on-full"
      >
        <div
          className={`text-end mt-1 d-flex justify-content-between align-items-center`}
        >
          <DialogTitle
            sx={{
              paddingY: 0,
              color: get_root_value("--portal-theme-primary"),
            }}
          >
            Save As template
          </DialogTitle>

          <IconButton
            className="back-screen-button me-1 "
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className="position-sticky top-0 start-0 d-flex justify-content-between bg-white"></div>

        {isLoading ? (
          <DialogContent
            sx={{
              maxHeight: "75vh",
              overflowY: "auto",
            }}
          >
            <CircularProgress className={classes.loading} color="primary" />
          </DialogContent>
        ) : (
          <>
            <DialogContent
              sx={{
                maxHeight: "75vh",
                overflowY: "auto",
              }}
            >
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
                    <TextField
                      id="outlined-basic"
                      label="Programme Name*"
                      variant="outlined"
                      fullWidth
                      name="title"
                      value={inputs.title}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
                    <TextField
                      id="outlined-basic"
                      label="Video Url "
                      variant="outlined"
                      fullWidth
                      name="videoUrl"
                      value={inputs.videoUrl}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Programme Status *
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        name="programStatus"
                        value={inputs.programStatus}
                        label="Programme Status *"
                        onChange={handleChange}
                      >
                        <MenuItem value="true">Active</MenuItem>
                        <MenuItem value="false">Inactive</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
                    <FormControl fullWidth disabled>
                      <InputLabel id="demo-simple-select-label">
                        Programme Type *
                      </InputLabel>
                      <Select
                        disabled
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        name="program_type"
                        value={inputs.program_type}
                        label="Programme Length*"
                        onChange={handleChange}
                      >
                        <MenuItem value="general">General</MenuItem>
                        <MenuItem value="video">Video</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Programme Length Type *
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        name="accessType"
                        value={inputs.accessType}
                        label="Programme Length Type *"
                        onChange={handleChange}
                        readOnly
                      >
                        <MenuItem value="limited">Limited</MenuItem>
                        <MenuItem value="unlimited">Unlimited</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  {inputs.accessType == "limited" && (
                    <>
                      <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
                        <FormControl fullWidth>
                          <TextField
                            id="outlined-basic"
                            label="No Of Weeks"
                            variant="outlined"
                            type="number"
                            InputProps={{ inputProps: { min: 0 } }}
                            placeholder="No Of Weeks"
                            fullWidth
                            required
                            name="no_of_weeks"
                            value={inputs.no_of_weeks}
                            onChange={handleChange}
                          />
                          {weeklength > inputs.no_of_weeks && (
                            <FormHelperText sx={{ fontSize: 10 }}>
                              {<InfoIcon sx={{ width: 15 }} />} Due to the
                              reduction in length, your workout will be deleted
                              for the items beyond this reduced length.
                            </FormHelperText>
                          )}
                        </FormControl>
                      </div>
                    </>
                  )}

                  <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
                    <TextField
                      fullWidth
                      id="color"
                      type="color"
                      label="Color"
                      name="color"
                      variant="outlined"
                      required={true}
                      value={inputs.color}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
                    <div className="row w-100 div-style ms-0 pt-0">
                      <div className="col-lg-5 col-md-5 col-sm-12">
                        <p className="">Upload Image *</p>
                        <FormHelperText className="pt-0">
                          Image Size(1000 X 670) ("JPG", "JPEG", "PNG","WEBP")
                        </FormHelperText>
                      </div>
                      <div className="col-lg-2 col-md-2 col-6">
                        {file ? (
                          <img
                            className="image-border"
                            src={file}
                            height="50"
                          />
                        ) : (
                          <img
                            className="image-border"
                            src={s3baseUrl + inputs.image_show}
                            height="50"
                          />
                        )}
                      </div>
                      <div className="col-lg-5 col-md-5 col-6 text-end pt-2">
                        <label htmlFor="contained-button-file">
                          <Input
                            accept="image/*"
                            id="contained-button-file"
                            multiple
                            type="file"
                            name="image"
                            onChange={fileChangedHandler}
                          />

                          <Button
                            className="small-contained-button"
                            startIcon={<FileUploadIcon />}
                            component="span"
                          >
                            Upload
                          </Button>
                        </label>
                      </div>
                    </div>
                    {inputs?.image?.name == "" ? (
                      ""
                    ) : (
                      <p className="text-secondary">{inputs?.image?.name}</p>
                    )}
                  </div>

                  <div className="col-12 mt-5">
                    <FormControl fullWidth>
                      <TextField
                        id="outlined-multiline-flexible"
                        label="Short Description "
                        multiline
                        rows={6}
                        required
                        name="short_description"
                        value={inputs.short_description}
                        onChange={handleChange}
                      />
                      <FormHelperText>
                        Maximum limit 200 characters
                      </FormHelperText>
                    </FormControl>
                  </div>
                  <div className="col-12 mt-5">
                    <h4>Detail Description *</h4>
                    <TinyEditor
                      setDetailDescription={setDetailDescriptionCk}
                      detailDescriptionCk={detailDescriptionCk}
                    />
                  </div>
                </div>
              </form>
            </DialogContent>
            <DialogActions>
              <div className="text-end">
                <button
                  type="submit"
                  onClick={(e) => handleSubmit(e)}
                  className="small-contained-button"
                >
                  Submit
                </button>
              </div>
            </DialogActions>{" "}
          </>
        )}
      </Dialog>
    </div>
  );
}
